import React from 'react';
import { Routes, Route } from 'react-router-dom';
import EmbedLayout from './components/EmbedLayout';

// Import calculator components
import CarLoanCalculator from './pages/CarLoanCalculator';
import CarLoanEMICalculator from './pages/CarLoanEMICalculator';
import CarLoanInterestCalculator from './pages/CarLoanInterestCalculator';
import CarLoanAmortizationCalculator from './pages/CarLoanAmortizationCalculator';
import StampDutyCalculator from './pages/StampDutyCalculator';
import FourWDLoanCalculator from './pages/FourWDLoanCalculator';
import UteTruckLoanCalculator from './pages/UteTruckLoanCalculator';
import FarmVehicleFinanceCalculator from './pages/FarmVehicleFinanceCalculator';
import MilitaryVeteranLoanCalculator from './pages/MilitaryVeteranLoanCalculator';
import MilitaryRelocationLoanCalculator from './pages/MilitaryRelocationLoanCalculator';
import EarlyPayoffCalculator from './pages/EarlyPayoffCalculator';
import LeaseVsBuyCalculator from './pages/LeaseVsBuyCalculator';

// Define calculator routes with their titles
const calculatorRoutes = [
  { path: '/car-loan-calculator', component: CarLoanCalculator, title: 'Car Loan Repayment Calculator' },
  { path: '/car-loan-emi-calculator', component: CarLoanEMICalculator, title: 'Car Loan EMI Calculator' },
  { path: '/car-loan-interest-calculator', component: CarLoanInterestCalculator, title: 'Car Loan Interest Calculator' },
  { path: '/car-loan-amortization-calculator', component: CarLoanAmortizationCalculator, title: 'Car Loan Amortization Schedule Calculator' },
  { path: '/stamp-duty-calculator', component: StampDutyCalculator, title: 'Vehicle Stamp Duty Calculator' },
  { path: '/early-payoff-calculator', component: EarlyPayoffCalculator, title: 'Car Loan Early Payoff Calculator' },
  { path: '/lease-vs-buy-calculator', component: LeaseVsBuyCalculator, title: 'Car Lease vs Buy Calculator' },
  { path: '/4wd-loan-calculator', component: FourWDLoanCalculator, title: '4WD Loan Calculator' },
  { path: '/ute-truck-loan-calculator', component: UteTruckLoanCalculator, title: 'Ute & Truck Loan Calculator' },
  { path: '/farm-vehicle-finance-calculator', component: FarmVehicleFinanceCalculator, title: 'Farm Vehicle Finance Calculator' },
  { path: '/military-veteran-loan-calculator', component: MilitaryVeteranLoanCalculator, title: 'Military & Veteran Car Loan Calculator' },
  { path: '/military-relocation-loan-calculator', component: MilitaryRelocationLoanCalculator, title: 'Military Relocation Car Loan Calculator' }
];

const EmbedRouter: React.FC = () => {
  return (
    <Routes>
      {calculatorRoutes.map(({ path, component: Component, title }) => (
        <Route
          key={path}
          path={`/embed${path}`}
          element={
            <EmbedLayout calculatorName={title} path={path}>
              <Component />
            </EmbedLayout>
          }
        />
      ))}
    </Routes>
  );
};

export default EmbedRouter;
